var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4"},[_vm._v("This survey is "+_vm._s(_vm.survey.status))])}
var staticRenderFns = []

export { render, staticRenderFns }